import { defineMessages } from 'react-intl';
import { ProductCategoryDuplicateName } from '../code-constants';

export const messages = defineMessages({
  [ProductCategoryDuplicateName]: {
    description: 'Save Reporting Category error message when name to save matches an existing reporting category name',
    defaultMessage: 'Unable to save Reporting Category, name must be unique.',
    id: 'LeyNOy',
  },
});

export const reportingCategoryErrors = ({ code }) => {
  return messages[code];
};
